import { useEffect, useState } from "react"
import * as React from "react"
import { ConnectionType, PaginationType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, Link, redirect } from "@tanstack/react-router"
import { useReactToPrint } from "react-to-print"

import { canViewThisPage } from "@/lib/api/auth"
import { getConnectionType } from "@/lib/api/billing"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { connectionTypesColumn } from "@/components/table/columns/connection-types-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddConnectionTypesPage from "./add"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/connection-type/",
)({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_connectiontype")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: ConnectionTypesPage,
})

function ConnectionTypesPage() {
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)

  const isConnectionTypeDropdown = false
  const {
    data: connectionTypesDetails,
    isError,
    isLoading,
  } = useQuery<ConnectionType[]>({
    queryKey: ["connectionTypesDetails"],
    queryFn: () => getConnectionType(isConnectionTypeDropdown),
  })

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <main className="space-y-4 p-4">
      <Header>Connection Types</Header>
      <div className="print:p-2" ref={contentRef}>
        <DataTable
          columns={connectionTypesColumn}
          data={connectionTypesDetails ?? []}
          search={{
            field: "type_name",
            label: "Name",
          }}
          isLoading={isLoading}
          isError={isError}
          //tableTitle="Connection type"
        >
          <div className="flex w-full justify-end">
            <AddConnectionTypesPage />
          </div>
          <Button onClick={() => reactToPrintFn()}>
            <Icons.download />
            Print Connection Type
          </Button>
          <ExportOperationModal
            tableData={connectionTypesDetails ?? [{}]}
            fileName="Connection Type"
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
          />
        </DataTable>
      </div>
    </main>
  )
}
